import React from "react";
import {
  MediaCarouselProps,
  MediaCarousel,
} from "@/components/carousel/MediaCarousel";
import { usePdpProduct } from "@/features/pdp/PdpContext";

export const PdpCarousel = (
  props: Omit<MediaCarouselProps, "media" | "title">
) => {
  const product = usePdpProduct();

  const inp = {
    ...props,
    title: product.title,
    media: product.media,
  };

  return <MediaCarousel {...inp} />;
};
